
import appConfig, {channelEnum} from "../appconfig";
import * as actions from "../store/mutation-types";
import {mapGetters} from "vuex";
import {pushGTMInternal} from "../integrations/tracking/gtm/pushGtmEvents";

export default {
	data() {
		return {
			sendingOrderPayAtCounter: false
		};
	},
	computed: {
		...mapGetters(["featureToggles"]),
		isKiosk() {
			return appConfig.channelAlias() === channelEnum.kiosk;
		}
	},
	methods: {
		async handlePayAtCounter() {
			if(!this.isKiosk || !this.featureToggles.postpaidOrdersEnabled) {
				return;
			}
			this.sendingOrderPayAtCounter = true;
			this.$store.dispatch(actions.CART_SUBMIT_ORDER_BM100).then(() => {
				this.sendingOrderPayAtCounter = false;
				this.$router.push("/pay-at-counter");
			}).catch(() => {
				this.sendingOrderPayAtCounter = false;
			});
			pushGTMInternal(
				"kiosk_pay_at_counter_selected",
				this.$route.name,
				this.$route.path,
				"basket"
			);

		}	}
};
